import { Selector } from "react-redux";
import { useAppSelector } from "../../../services/redux/hooks/use-selector";

export function createEntitySelectorHook<
  TSelectors extends Record<string, Selector<any, any>>,
>(selectors: TSelectors) {
  return function useEntity<TKey extends keyof TSelectors>(key: TKey) {
    const selector = selectors[key];

    return useAppSelector(selector);
  };
}
